import React, { Component } from "react";
import { goBack } from "react-router-redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import CroMunicipality from "../../components/generalForm/CroMunicipality";
import CroCountry from "../../components/generalForm/CroCountry";
import CroField from "../../components/generalForm/CroField";
import CroSubhead from "../../components/generalForm/CroSubhead";
import { styles } from "../../index";
import { changeProfile, getMe } from "../../CroActions";
import {
  breadcrumbs,
  togglePanel,
  setLoading,
} from "../../../../actions/appActions";
import { isOfficial } from "../../CroUtils";
import * as V from "../../../../utils/formValidation";
import H from "../../helpEnum";
import { convert, addressToForm } from "../../converts";

const FORM_NAME = "changeProfileForm";

class ChangeProfileForm extends Component {
  state = { email: "" };

  async componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);

    const { auth, initialize, dispatch } = this.props;
    if (isOfficial(auth)) {
      dispatch(setLoading(true, "Načítání profilu..."));
      try {
        const { deliveryAddress, email, databox } =
          (await getMe(dispatch)) || {};
        this.setState({ email });
        const initObj = { address: deliveryAddress, email, databox };
        initialize(convert(initObj, { address: addressToForm }));
      } finally {
        dispatch(setLoading());
      }
    }
  }

  render() {
    const {
      router: { goBack },
      error,
      handleSubmit,
      onSubmit,
      submitting,
      disabled,
    } = this.props;

    return (
      <form onSubmit={handleSubmit(onSubmit)} className="changeProfileForm">
        {/* === Adresa === */}
        <div className="changeProfileForm__section">
          <CroSubhead title="Adresa pro doručování" />
          <div className="changeProfileForm__grid">
            <CroCountry
              title="Stát"
              name="address"
              disabled={disabled}
              form={FORM_NAME}
            />
            <CroMunicipality
              title="Obec"
              name="address"
              disabled={disabled}
              form={FORM_NAME}
            />
            <CroField
              title="Ulice"
              name="address.street"
              component={Input}
              disabled={disabled}
            />
            <CroField
              title="Č.p./Č.o."
              name="address.orientationNumber"
              component={Input}
              disabled={disabled}
              helpEnum={H.HOUSE_NUMBER.r}
            />
            <CroField
              title="PSČ"
              name="address.zip"
              component={Input}
              disabled={disabled}
            />
          </div>
        </div>

        {/* === Kontaktné údaje === */}
        <div className="changeProfileForm__section">
          <CroSubhead title="Kontaktní údaje" />
          <div className="changeProfileForm__grid">
            {this.state && this.state.email && this.state.email.length > 0 ? (
              <CroField
                title="E-mail"
                name="email"
                component={Input}
                disabled={disabled}
                validate={[V.required, V.email]}
                hintText="@"
              />
            ) : (
              <CroField
                title="E-mail"
                name="email"
                component={Input}
                disabled={disabled}
                validate={[V.email]}
                hintText="@"
              />
            )}
            <CroField
              title="Datová schránka"
              name="databox"
              component={Input}
              disabled={disabled}
            />
          </div>
        </div>

        {/* === Footer === */}
        <div className="changeProfileForm__footer">
          <div className="changeProfileForm__footerInner">
            {error && <div className="error">{error}</div>}
            {!this.props.valid && this.props.submitFailed && !error && (
              <div className="error">Povinná pole nejsou správně vyplněna.</div>
            )}
            {!this.props.valid && this.props.submitFailed && !error && (
              <div className="error">
                Není povoleno smazat email. Můžete ho editovat.
              </div>
            )}
            {!disabled && (
              <div className="changeProfileForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>
            )}
            <div className="changeProfileForm__actions">
              <Button
                type="submit"
                style={styles.buttons}
                label="Odeslat"
                disabled={submitting}
              />
              <Button
                type="button"
                style={styles.buttons}
                label="Zpět"
                disabled={submitting}
                onClick={goBack}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const Form = reduxForm({
  form: FORM_NAME,
})(ChangeProfileForm);

const mapStateToProps = (state) => ({
  breadcrumbsItems: [{ label: "Změna profilu" }],
});

const onSubmit = (url, data) => async (dispatch) => {
  await changeProfile(data, dispatch, url);
  dispatch(togglePanel("Profil úspěšně změněn"));
  dispatch(goBack());
};

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators({ breadcrumbs }, dispatch),
  onSubmit: (data) => onSubmit(`${auth.startUrl}/api/profil`, data)(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
